import { Link } from "react-router-dom";

import t from "../../i18n/i18n";
import initPage from "../../utils/initPage";

import Template from "../../template/template";
import Header from "./header/header";
import MyRequests from "./myRequests/myRequests";

function Success() {
  initPage({ title: "" });

  return (
    <Template>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="support-warp">
              <div className="support-warp-main">
                <Header />

                <div className="support-content">
                  {/* <div className="support-search">
                    <h4>PESQUISAR NA CENTRAL DE SUPORTE</h4>
                    <div className="input-text icon-search">
                      <input type="text" value="" pattern="" />
                    </div>
                  </div> */}

                  <div className="support-form">
                    <div className="support-form-header">
                      <h1>{t("Support.Menu.Request")}</h1>
                    </div>

                    <div className="support-form-data">
                      <div className="form-data-box">
                        <div className="form-submit-info">
                          <div className="submit-title">
                            <div className="ico">
                              <img src="/images/check-ico-large.png" alt="" />
                            </div>

                            <h2>{t("Support.Success")}</h2>
                          </div>

                          <p>{t("Support.SuccessMessage")}</p>
                          <div className="btn-box">
                            <Link to="/" className="btn btn-primary">
                              {t("Support.Link")}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>

                    <MyRequests />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Template>
  );
}

export default Success;
